<script>
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import client from "../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		loadingStatus,
		carparkDetail,
		imageLightbox,
	} from "../../../store/store";
	import LotTable from "./LotTable.svelte";
	import CarTable from "./CarTable.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import { convert } from "../../../services/helpers";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte"; //lightbox with image
	import {
		extractErrorMessage,
		resDataToArr,
		truncateToDp,
	} from "src/utils/misc";
	import { brand } from "src/brand";
	import CustomBreadcrumb from "src/components/CustomBreadcrumb/CustomBreadcrumb.svelte";
	export let carParkId;

	let detailData;
	let modalOpen = false;
	let imageShowingIndex = 0;

	async function fetchCarParks() {
		try {
			loading.set(true);
			const response = await client(`/v1/carParks/${carParkId}`, {
				method: "GET",
				version: "Vehicle",
			});
			detailData = response.data;
			carparkDetail.set(response.data);
			let images = response.data.carParkImages.map((item) => {
				return item.fileUrl;
			});
			imageLightbox.set(images);
			loading.set(false);
		} catch (error) {
			loading.set(false);
			extractErrorMessage(error);
		}
	}

	onMount(() => {
		fetchCarParks();
	});

	const handleImgClick = () => {
		imageShowingIndex = 0;
		modalOpen = true;
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<CustomBreadcrumb
	links={[
		{ label: "Car park management", to: "/carpark-management" },
		{ label: "Car park details" },
	]}
/>

{#if !detailData}
	<LoaderContainer />
{:else}
	<LoaderContainer>
		<Row>
			<ErrorMessageHandler message={err} />
			<Col xxl={12} xs={12}>
				<PageHeader title="Car park details" />
			</Col>
			<Col xs={6}>
				<Row class="my-3">
					<Col xs={3}>
						<span> Car park ID </span>
					</Col>
					<Col>
						<b>{detailData.carParkId}</b>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Address</span></Col>
					<Col>
						<b>{detailData.address}</b>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Postal code</span></Col>
					<Col>
						<b>{detailData.postalCode}</b>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Car park Owner</span></Col>
					<Col>
						<b>{detailData.carParkOwner.name}</b>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Description</span></Col>
					<Col>
						<b>{detailData.description}</b>
					</Col>
				</Row>
				{#if brand.isCarparkCoordinatesEnabled}
					<Row class="my-3">
						<Col xs={3}><span>Coordinates</span></Col>
						<Col>
							<b
								>{detailData.latitude != null &&
								detailData.longitude != null
									? `${truncateToDp(
											detailData.latitude,
											6
										)}, ${truncateToDp(
											detailData.longitude,
											6
										)}`
									: "-"}</b
							>
						</Col>
					</Row>
				{/if}
				<Row class="my-3">
					<Col xs={3}><span>No. of lots</span></Col>
					<Col>
						<b>{detailData.carParkLots.length}</b>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Status</span></Col>
					<Col xs={3}>
						{#if detailData.status}
							<p class="status-bar status-bar-1">Active</p>
						{:else if !detailData.status}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Photo(s) of car park</span></Col>
					<Col xs={3}>
						<p
							class="link"
							on:keydown={() => {}}
							on:click={() => {
								if (detailData.carParkImages.length === 0) {
									return;
								} else {
									handleImgClick();
								}
							}}
						>
							<span class="link link-text">
								{detailData.carParkImages.length} Image(s)
							</span>
						</p>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>Start date</span></Col>
					<Col>
						<b>{convert(detailData.activeFrom)}</b>
					</Col>
				</Row>
				<Row class="my-3">
					<Col xs={3}><span>End date</span></Col>
					<Col>
						<b>{convert(detailData.activeTo)}</b>
					</Col>
				</Row>
			</Col>
			<Col xs={6}>
				<Col class="d-flex justify-content-end me-4">
					<Row>
						<Col>
							<Button
								on:click={() =>
									navigate(
										`/carpark-management/details/edit/${carParkId}`
									)}
								class="themeButton primary">Edit</Button
							>
						</Col>
					</Row>
				</Col>
			</Col>
			<Col xs={12}>
				<div class="line" />
			</Col>
		</Row>
		<LotTable
			dataLot={detailData.carParkLots}
			{carParkId}
			trigerFetch={fetchCarParks}
		/>
		<Col xs={12}>
			<div class="line" />
		</Col>
		<CarTable dataCar={detailData.vehicles} trigerFetch={fetchCarParks} />
	</LoaderContainer>
{/if}

<style>
	.line {
		width: 100%;
		border: 1px solid #f0eaea;
		display: inline-block;
	}
</style>
